import {
  type SuperUserActionTypes,
  SuperUserRequestKey,
  TypeKeys,
} from "actions/super_user";
import type { IFeatureFlagMerchantStatuses } from "interfaces/super_users/feature_flags";
import type { IMerchantGroup } from "interfaces/super_users/merchant_group_sessions";
import { RequestStatus } from "types/request";

export interface ISuperUserState {
  merchantGroups: IMerchantGroup[];
  merchantGroupsQuery: string;
  requestStates: { [key in SuperUserRequestKey]: RequestStatus };
  featureFlagNames: string[];
  featureFlagStatuses: IFeatureFlagMerchantStatuses;
}

const initialState: ISuperUserState = {
  merchantGroups: [],
  merchantGroupsQuery: "",
  requestStates: {
    [SuperUserRequestKey.GetFeatureFlags]: RequestStatus.NOT_STARTED,
    [SuperUserRequestKey.GetFeatureFlagStatuses]: RequestStatus.NOT_STARTED,
    [SuperUserRequestKey.SearchMerchantGroups]: RequestStatus.NOT_STARTED,
    [SuperUserRequestKey.StartMerchantGroupsSession]: RequestStatus.NOT_STARTED,
    [SuperUserRequestKey.StopMerchantGroupsSession]: RequestStatus.NOT_STARTED,
  },
  featureFlagNames: [],
  featureFlagStatuses: {
    enabled: [],
    disabled: [],
  },
};

function superUser(
  state: ISuperUserState = initialState,
  action: SuperUserActionTypes
): ISuperUserState {
  switch (action.type) {
    case TypeKeys.SET_SUPER_USER_REQUEST_STATUS_ACTION: {
      const { requestKey, requestStatus } = action;
      return {
        ...state,
        requestStates: {
          ...state.requestStates,
          [requestKey]: requestStatus,
        },
      };
    }
    case TypeKeys.SET_MERCHANT_GROUPS_QUERY_ACTION: {
      const { query } = action;
      return { ...state, merchantGroupsQuery: query };
    }
    case TypeKeys.SEARCH_MERCHANT_GROUPS: {
      const { merchantGroups } = action;
      return { ...state, merchantGroups };
    }
    case TypeKeys.START_MERCHANT_GROUP_SESSION: {
      return state;
    }
    case TypeKeys.STOP_MERCHANT_GROUP_SESSION: {
      return state;
    }
    case TypeKeys.SET_FEATURE_FLAGS: {
      const { featureFlagNames } = action;
      return {
        ...state,
        featureFlagNames,
      };
    }
    case TypeKeys.SET_FEATURE_FLAG_STATUSES: {
      const { featureFlagStatuses } = action;
      return {
        ...state,
        featureFlagStatuses,
      };
    }
    default:
      return state;
  }
}

export default superUser;
